import api from '@/utils/ky'

// Outline share links now come from core (admin/v2/articles/shares) instead of
// straight from Outline: the Outline API token is server-side only and must
// never reach the browser, and love's nginx has no /blog proxy in production.
export async function fetchArticles() {
  const res = await api.get('admin/v2/articles/shares')
  const articles = res?.data

  if (!Array.isArray(articles)) {
    console.error(
      '💈 LOG → fetchArticles → failed:',
      articles?.err ?? articles
    )
    return []
  }

  console.log('💈 LOG → fetchArticles → articles.length:', articles.length)

  return articles
}
